import React, { useEffect } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

interface Props {
  open: boolean
  title: string
  subtitle: string
}

function LoaderDialog(props: Props) {
  useEffect(() => {}, [props.title])

  return (
    <div className="loader-dialog">
      <div className="alert-dialog-loading">
        <div className="alert-dialog-loading-icon">
          <CircularProgress color="secondary" />
        </div>
        <div className="alert-dialog-loading-title">
          {props.title}
          <span>...</span>
        </div>
        <div>{props.subtitle}</div>
      </div>
    </div>
  )
}

export default LoaderDialog
